module.exports = __webpack_public_path__ + "img/logo-plataforma_web_128.3ae219d4.png";